export default "__VITE_ASSET__B4$1yyhv__"